__turbopack_context__.v({
  "card": "AbtFeatures-module__IoY2XW__card",
  "desc": "AbtFeatures-module__IoY2XW__desc",
  "featBg": "AbtFeatures-module__IoY2XW__featBg",
  "number": "AbtFeatures-module__IoY2XW__number",
  "title": "AbtFeatures-module__IoY2XW__title",
  "wrapper": "AbtFeatures-module__IoY2XW__wrapper",
});
